// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-d9f0c028] .gm-ui-hover-effect {\n  width: 16px !important;\n  height: 16px !important;\n  top: -10px !important;\n  right: 20px !important;\n}\n[data-v-d9f0c028] .gm-ui-hover-effect span {\n  width: 16px !important;\n  height: 16px !important;\n}\n.gm-style .gm-style-iw[data-v-d9f0c028] {\n  font-weight: 400;\n}", ""]);
// Exports
module.exports = exports;
